import RasaUsersService from '@/services/users'

const state = {
    error: false,
    loading: false,
    userList: []
}

const mutations = {
    setError(state, payload) {
        state.error = payload;
    },
    setLoading(state, payload) {
        state.loading = payload;
    },
    loadUsers(state, user_list) {
        state.userList = user_list
    }
}

const actions = {
    async getUsers({ commit }) {
        commit('setError', false);
        commit('setLoading', true);

        try {
        await RasaUsersService.getAll().then(res => commit('loadUsers', res.data.users)) 
        } catch (error) {
            commit('setError', error);
        }

        commit('setLoading', false);
    }
}

const getters = {
    error: (state) => { return state.error },
    loading: (state) => { return state.loading },
    userList: (state) => { return state.userList },
}
export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
}